export enum VehicleType {
  Sedan = 'sedan',
  Hatchback = 'hatchback',
  StationWagon = 'station_wagon',
  Suv = 'suv',
  Truck = 'truck',
  Motorcycle = 'motorcycle',
  Bicycle = 'bicycle',
  EBike = 'e_bike',
  Scooter = 'scooter',
  EScooter = 'e_scooter',
  Van = 'van',
  CargoVan = 'cargo_van',
  BoxTruck = 'box_truck',
}

export const vehicleFormTypes = [
  { label: 'Sedan', value: VehicleType.Sedan },
  { label: 'Hatchback', value: VehicleType.Hatchback },
  { label: 'Station Wagon', value: VehicleType.StationWagon },
  { label: 'Suv', value: VehicleType.Suv },
  { label: 'Truck', value: VehicleType.Truck },
  { label: 'Van', value: VehicleType.Van },
  { label: 'Cargo Van', value: VehicleType.CargoVan },
  { label: 'Motorcycle', value: VehicleType.Motorcycle },
  { label: 'Bicycle', value: VehicleType.Bicycle },
  { label: 'E-Bicycle', value: VehicleType.EBike },
  { label: 'Scooter', value: VehicleType.Scooter },
  { label: 'E-Scooter', value: VehicleType.EScooter },
  { label: 'Box Truck', value: VehicleType.BoxTruck },
]

export const nonInsuredVehicles = [
  VehicleType.Bicycle,
  VehicleType.EBike,
  VehicleType.Scooter,
  VehicleType.EScooter,
]
